import { Injectable } from '@angular/core';
import FroalaEditor from 'froala-editor';

@Injectable({
  providedIn: 'root'
})
export class FroalaCustomCommandsService {
  public registerCustomCommands(): void {
    this.registerCodeBlockCommand();
    this.registerTextDirectionCommands();
    this.registerParagraphFormatButton();
    this.registerH1Button();
    this.registerH2Button();
    this.registerFormatULSimple();
  }

  private registerCodeBlockCommand(): void {
    FroalaEditor.DefineIcon('codeBlock', { SVG_KEY: 'codeSnippet' });
    FroalaEditor.RegisterCommand('codeBlock', {
      title: 'Code Block',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        const editor = this;
        const blocks = editor.selection.blocks();

        // Check if we're in a code block
        if (blocks.length && blocks[0].tagName.toLowerCase() === 'pre') {
          // Toggle off - convert code block to paragraph
          editor.paragraphFormat.apply('p');
        } else {
          // Toggle on - convert to code block
          editor.paragraphFormat.apply('pre');
        }
      },
      refresh: function ($btn) {
        const blocks = this.selection.blocks();
        if (blocks.length) {
          const tag = blocks[0].tagName.toLowerCase();
          $btn.toggleClass('fr-active', tag === 'pre');
        }
      }
    });
  }

  private registerTextDirectionCommands(): void {
    const changeDirection = function (dir: string, align: string) {
      this.selection.save();
      this.html.wrap(true, true, true, true);
      this.selection.restore();

      const elements = this.selection.blocks();
      this.selection.save();

      for (const element of elements) {
        if (element != this.el) {
          this.$(element).css('direction', dir).css('text-align', align).removeClass('fr-temp-div');
        }
      }

      this.html.unwrap();
      this.selection.restore();
    };

    FroalaEditor.DefineIcon('rightToLeft', { NAME: 'long-arrow-left' });
    FroalaEditor.RegisterCommand('rightToLeft', {
      title: 'Toggle Text Direction',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        const selection = this.selection.element();
        const currentDir = this.$(selection).css('direction');

        if (currentDir === 'rtl') {
          changeDirection.apply(this, ['ltr', 'left']);
        } else {
          changeDirection.apply(this, ['rtl', 'right']);
        }
      }
    });
  }

  private registerParagraphFormatButton(): void {
    // Replace the paragraphFormat icon with text for clarity
    FroalaEditor.DefineIconTemplate('paragraph_text', '<span style="font-size: 14px; padding: 0 5px;">Paragraph Format</span>');
    FroalaEditor.DefineIcon('paragraphFormat', { template: 'paragraph_text' });
  }

  private registerH1Button(): void {
    FroalaEditor.DefineIconTemplate('h1_text', '<span style="font-size: 14px; font-weight: bold; padding: 0 5px;">H1</span>');
    FroalaEditor.DefineIcon('heading1', { template: 'h1_text' });
    FroalaEditor.RegisterCommand('heading1', {
      title: 'Heading 1',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        const blocks = this.selection.blocks();
        if (blocks.length && blocks[0].tagName.toLowerCase() === 'h1') {
          this.paragraphFormat.apply('p');
        } else {
          this.paragraphFormat.apply('h1');
        }
      },
      refresh: function ($btn) {
        const blocks = this.selection.blocks();
        if (blocks.length) {
          const tag = blocks[0].tagName.toLowerCase();
          $btn.toggleClass('fr-active', tag === 'h1');
        }
      }
    });
  }

  private registerH2Button(): void {
    FroalaEditor.DefineIconTemplate('h2_text', '<span style="font-size: 14px; font-weight: bold; padding: 0 5px;">H2</span>');
    FroalaEditor.DefineIcon('heading2', { template: 'h2_text' });
    FroalaEditor.RegisterCommand('heading2', {
      title: 'Heading 2',
      focus: true,
      undo: true,
      refreshAfterCallback: true,
      callback: function () {
        const blocks = this.selection.blocks();
        if (blocks.length && blocks[0].tagName.toLowerCase() === 'h2') {
          this.paragraphFormat.apply('p');
        } else {
          this.paragraphFormat.apply('h2');
        }
      },
      refresh: function ($btn) {
        const blocks = this.selection.blocks();
        if (blocks.length) {
          const tag = blocks[0].tagName.toLowerCase();
          $btn.toggleClass('fr-active', tag === 'h2');
        }
      }
    });
  }

    private registerFormatULSimple(): void {
    // Re-register formatUL without the type dropdown — always inserts a disc bullet list.
    // formatOL keeps its dropdown (lower-alpha, lower-roman, etc.) unchanged.
    FroalaEditor.RegisterCommand('formatUL', {
      title: 'Unordered List',
      type: 'button',
      hasOptions: false,
      refresh: function ($btn) {
        this.lists.refresh($btn, 'UL');
      },
      callback: function () {
        (this.lists as any).format('UL');
      },
      plugin: 'lists'
    });
  }
}
